/**
 * Save all daily messages for a stage via AJAX
 * @param {string} stageId - Stage post ID
 * @param {Object} messages - Object with message_day_1 to message_day_7 keys
 * @returns {Promise<boolean>} Success status
 */
export async function saveAllDailyMessages(stageId, messages) {
	const formData = new FormData();
	formData.append('action', 'wpcore_save_daily_messages');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);

	// Append messages array
	Object.keys(messages).forEach(key => {
		formData.append(`messages[${key}]`, messages[key]);
	});

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (!data.success) {
			console.error('Error:', data.data?.message);
		}

		return data.success;
	} catch (error) {
		console.error('Error saving daily messages:', error);
		return false;
	}
}
